import { render, staticRenderFns } from "./error-page.vue?vue&type=template&id=233016f4&scoped=true"
import script from "./error-page.vue?vue&type=script&lang=js"
export * from "./error-page.vue?vue&type=script&lang=js"
import style0 from "./error-page.vue?vue&type=style&index=0&id=233016f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233016f4",
  null
  
)

export default component.exports